/// <reference path="references.ts" />
var PageHomeEntryForm = /** @class */ (function () {
    //Variables
    //Methods
    function PageHomeEntryForm() {
        var thisObj = this; //store reference to self for assigning onclick function calls to a dynamic object method
        console.log('Root URL: ' + Apfco.rootUrl);
        //var test = 1;
    }
    return PageHomeEntryForm;
}());
//# sourceMappingURL=PageHomeEntryForm.js.map